import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import TrustIndicators from './components/TrustIndicators';

const Register = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // API base URL
  const API_URL = import.meta.env?.VITE_SERVER_URL || 'http://localhost:4000';

  // Check if user is already authenticated
  useEffect(() => {
    const token = localStorage.getItem('ddf_token');
    if (token) {
      // User is already logged in, redirect to dashboard
      navigate('/news-generation', { replace: true });
    }
  }, [navigate]);

  // Registration function
  const handleRegistration = async (formData) => {
    setLoading(true);
    setError(null);

    try {
      // Call backend registration
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          name: formData?.fullName,
          email: formData?.email,
          password: formData?.password
        })
      });
      const data = await res.json();
      if (!data?.success) {
        throw new Error(data?.message || 'Registration failed. Please try again.');
      }

      // DON'T set token or user data - user needs to login
      // Show success message and redirect to login
      const successMessage = `Welcome to News Mind AI, ${formData?.fullName}! Please login to continue.`;
      
      // Redirect to login page
      setTimeout(() => {
        navigate('/login', { 
          replace: true,
          state: { 
            message: successMessage,
            type: 'success',
            email: formData?.email // Pre-fill email on login page
          }
        });
      }, 500);

    } catch (err) {
      setError(err?.message || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="w-full max-w-md space-y-8">
        <RegistrationHeader />
        
        <RegistrationForm
          onSubmit={handleRegistration}
          loading={loading}
          error={error}
        />
        
        <TrustIndicators />
      </div>
    </div>
  );
};

export default Register;